import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Configuration from "../../Configuration";

/**
 * Class representing an annotation text.
 */
class Annotation extends React.Component
{
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        const {className, children} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "digital-one cccu-annotation ap":"");
        const classes = classNames(
            "annotation",
            "d-block",
            client,
            {
                [className]: className !== undefined
            }
        );

        return (
            <div className={classes}>{children}</div>
        )
    }
}

export default Annotation;


// WEBPACK FOOTER //
// ./src/components/widgets/Annotation.js